module.exports = __webpack_public_path__ + "static/media/scan.dc8ace34.svg";